import React from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {roles} from "../utils/auth";
import {Redirect} from "react-router-dom";

/**
 *
 * @param auth
 * @returns {{geUserDefaultComponent()}}
 * @constructor
 */
function DefaultPage({auth}) {
    const {role} = auth;

    const geUserDefaultComponent = (role) => {
        switch (role) {
            // select default page based on the user's role
            case roles.ADMIN:
            case roles.GK:
            case roles.SMS:
                return <Redirect to="/fulfillment/contracts"/>;

            case roles.BAM:
                return <Redirect to="/company/customers"/>;

            case roles.CUSTOMER_REP:
                return <Redirect to="/customers/contracts"/>;
            default:
                // TODO return something went wrong components (ooops)
                return null
        }
    };
    return (
            <>
                {geUserDefaultComponent(role)}
            </>
    );
}

DefaultPage.propTypes = {};
DefaultPage.defaultProps = {};

const mapStateToProps = (state) => ({auth: state.auth});
export default connect(mapStateToProps)(DefaultPage)
